import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 0;
  /* Pinned rather than left to the static position: rendered inside the app
     shell's content area that position is offset past the sidebar, and a 100vw
     box from there overflows the viewport horizontally. */
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #dedee0;
  z-index: 100;
  display: grid;
  place-items: center;
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const LoadingImage = styled.img`
  animation: ${pulse} 1.5s infinite ease-in-out;
`;
